import axios from 'axios';
import qs from 'qs';
import { pickBy } from 'lodash';

import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

let cancelTokenList;
let cancelTokenPagination;
let cancelTokenConfig;
export const getTicketsUrl = (payload) => {
  if (typeof cancelTokenList !== typeof undefined) {
    cancelTokenList.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenList = axios.CancelToken.source();
  return axiosInstance.get('/tickets/list', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenList.token,
  });
};

export const getTicketsPagination = (payload) => {
  if (typeof cancelTokenPagination !== typeof undefined) {
    cancelTokenPagination.cancel('Operation canceled due to new request.');
  }

  const parsedPayload = pickBy(payload);
  cancelTokenPagination = axios.CancelToken.source();
  return axiosInstance.get('/tickets/list-pagination', {
    params: { ...parsedPayload, ...pickDevParams },
    cancelToken: cancelTokenPagination.token,
  });
};

export const getTicketConfig = () => {
  if (typeof cancelTokenConfig !== typeof undefined) {
    cancelTokenConfig.cancel('Operation canceled due to new request.');
  }

  cancelTokenConfig = axios.CancelToken.source();
  return axiosInstance.get('/tickets/configuration', { params: pickDevParams, cancelToken: cancelTokenConfig.token });
};

export const getTicketViewUrl = (id) => axiosInstance.get(`/tickets/view/${id}`, { params: pickDevParams });

export const getTicketsStaffCounts = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/tickets/staff-counts', { params: { ...parsedPayload, ...pickDevParams } });
};

export const getTicketsLevelCounts = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/tickets/level-counts', { params: { ...parsedPayload, ...pickDevParams } });
};

export const getTicketsStatusesCounts = (payload) => {
  const parsedPayload = pickBy(payload);
  return axiosInstance.get('/tickets/statuses-counts', { params: { ...parsedPayload, ...pickDevParams } });
};

export const addTicketUrl = (payload) => axiosInstance.post('/tickets/create', qs.stringify({ ...payload, ...pickDevParams }));

export const sendMessageUrl = (id, message, files) => axiosInstance.post(`/tickets/create-message/${id}`, { message, files, ...pickDevParams });

export const unreadMessageUrl = (id) => axiosInstance.post(`/tickets/unread/${id}`, qs.stringify(pickDevParams));

export const closeTicketUrl = (id, lock) => axiosInstance.post(`/tickets/close/${id}`, qs.stringify({ lock, ...pickDevParams }));

export const markAsSpamTicketUrl = (id, lock) => axiosInstance.post(`/tickets/mark-as-spam/${id}`, qs.stringify({ lock, ...pickDevParams }));

export const deleteTicketUrl = (id) => axiosInstance.post(`/tickets/delete/${id}`, qs.stringify(pickDevParams));

export const deleteMessageUrl = (id) => axiosInstance.post(`/tickets/delete-message/${id}`, qs.stringify(pickDevParams));

export const assignAdminUrl = (ticketId, assigned_admin_id) => axiosInstance.post(`/tickets/assignee/${ticketId}`, qs.stringify({ assigned_admin_id, ...pickDevParams }));

export const changeMassStatus = (payload) => axiosInstance.post('/tickets/bulk', qs.stringify({ ...payload, ...pickDevParams }));

export const changeTicketMessage = (id, message) => axiosInstance.post(`/tickets/edit-message/${id}`, qs.stringify({ message, ...pickDevParams }));

export const getRepliesList = () => axiosInstance.get('/ticket-replies/list', {
  params: pickDevParams,
});

export const createReply = (payload) => axiosInstance.post(
  '/ticket-replies/create',
  qs.stringify({
    ...payload,
    ...pickDevParams,
  }),
);

export const editReply = (id, payload) => axiosInstance.post(
    `/ticket-replies/edit/${id}`,
    qs.stringify({
      ...payload,
      ...pickDevParams,
    }),
);

export const deleteReply = (id) => axiosInstance.post(`/ticket-replies/delete/${id}`, qs.stringify(pickDevParams));

export const sortReplies = (items) => axiosInstance.post('/ticket-replies/sort', { items, ...pickDevParams });
